import React from 'react';
import { Link } from 'react-router-dom';

const WhoWeAre: React.FC = () => {
  return (
    <div className="who-we-are-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">Who We Are</h1>
          <nav className="flex justify-center animate-fadeInUp">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/about" className="hover:text-secondary">About</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Who We Are</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* About NEXEDZ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">About Us – NEXEDZ Private Limited</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                NEXEDZ Private Limited is an innovation-driven and future-focused organization committed to empowering individuals, entrepreneurs, and communities across Bharat. Through our integrated focus on <strong>Skill Development</strong>, <strong>Fintech Solutions</strong>, and <strong>Workforce Solutions</strong>, we strive to create meaningful opportunities that inspire growth, self-reliance, and digital empowerment.
              </p>
            </div>

            <div className="mb-12 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                With a clear vision of building a <strong>Self-Reliant Bharat</strong>, NEXEDZ operates through its two core business divisions:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-gradient-to-r from-primary to-secondary text-white p-8 rounded-lg shadow-lg text-center">
                  <i className="fas fa-laptop-code text-5xl mb-4"></i>
                  <h3 className="text-2xl font-bold">EDGE INFOTECH</h3>
                </div>
                <div className="bg-gradient-to-r from-secondary to-primary text-white p-8 rounded-lg shadow-lg text-center">
                  <i className="fas fa-rupee-sign text-5xl mb-4"></i>
                  <h3 className="text-2xl font-bold">EDGE PAISA</h3>
                </div>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                Each division plays a pivotal role in our mission to transform lives and businesses through technology, innovation, and nationwide accessibility.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-md animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              <p className="text-gray-700 text-lg leading-relaxed">
                At NEXEDZ, we are dedicated to bridging gaps, building capabilities, and enabling millions to participate confidently in India's evolving digital and economic landscape. Our commitment to excellence, inclusion, and impact drives us to deliver solutions that empower the nation — <strong>one skill, one service, and one opportunity at a time</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            {/* Vision */}
            <div className="mb-16 animate-fadeInUp">
              <div className="text-center mb-8">
                <i className="fas fa-eye text-5xl text-primary mb-4"></i>
                <h2 className="text-4xl font-bold mb-4">Our Vision</h2>
                <h3 className="text-2xl text-secondary font-semibold mb-4">
                  To build a Skilled, Empowered, and Self-Reliant Bharat.
                </h3>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed text-center">
                We envision a nation where every individual — regardless of region, background, or economic status — has access to the skills, technology, and opportunities needed to grow and succeed. Our vision is to make Bharat a global leader in digital empowerment, skill development, and inclusive economic progress.
              </p>
            </div>

            {/* Mission */}
            <div className="animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <div className="text-center mb-8">
                <i className="fas fa-bullseye text-5xl text-secondary mb-4"></i>
                <h2 className="text-4xl font-bold mb-6">Our Mission</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300">
                  <div className="flex items-start">
                    <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <i className="fas fa-graduation-cap text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Empower Through Skills</h4>
                      <p className="text-gray-600">
                        To provide high-quality, industry-relevant skill education that transforms learners into confident, job-ready professionals.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300">
                  <div className="flex items-start">
                    <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <i className="fas fa-globe text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Digital Access for All</h4>
                      <p className="text-gray-600">
                        To deliver essential fintech and digital services to every corner of Bharat, enabling individuals and businesses to participate fully in the digital economy.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300">
                  <div className="flex items-start">
                    <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <i className="fas fa-users text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Strengthen Workforce Development</h4>
                      <p className="text-gray-600">
                        To connect skilled individuals with real employment opportunities, bridging the gap between job seekers and industries.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300">
                  <div className="flex items-start">
                    <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <i className="fas fa-lightbulb text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Foster Innovation & Technology Adoption</h4>
                      <p className="text-gray-600">
                        To develop modern, technology-driven solutions that simplify services, enhance productivity, and promote digital inclusivity.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 md:col-span-2">
                  <div className="flex items-start">
                    <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <i className="fas fa-hands-helping text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold mb-2">Build Sustainable Community Impact</h4>
                      <p className="text-gray-600">
                        To uplift communities by providing long-term, scalable solutions that drive financial inclusion, skill advancement, and economic self-reliance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <i className="fas fa-heart text-5xl text-primary mb-4"></i>
              <h2 className="text-4xl font-bold mb-4">Our Core Values</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-shield-alt text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Integrity</h4>
                <p className="text-gray-600">
                  We maintain transparency and honesty in all our work.
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-rocket text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Innovation</h4>
                <p className="text-gray-600">
                  We continuously adopt new ideas and technologies to create impactful solutions.
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-handshake text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Inclusion</h4>
                <p className="text-gray-600">
                  We ensure equal access to skills, services, and opportunities for all.
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-star text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Excellence</h4>
                <p className="text-gray-600">
                  We strive to deliver the highest quality in everything we do.
                </p>
              </div>

              <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition duration-300 animate-fadeInUp md:col-span-2 lg:col-span-1" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-hands-helping text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Empowerment</h4>
                <p className="text-gray-600">
                  We believe in building capabilities that transform lives and strengthen Bharat.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhoWeAre;